import React, { Component } from 'react';
import { connect } from 'react-redux';
import progressicon from '../../assets/images/progressIcon.png';
import { Modal } from 'react-bootstrap';
import crossbtn from '../../assets/images/CongratulationModal/crossBtn.svg';
import BackArrow from '../../assets/images/CongratulationModal/back-arrow.svg';
import storytelling from '../../assets/images/CongratulationModal/storytelling.svg';
import imageplaceholder from '../../assets/images/imageplaceholder.png';
import authorimagePlaceholder from '../../assets/images/authorimagePlaceholder.png';
import { Multiselect } from 'multiselect-react-dropdown';
import apiV2 from '../../utils/apiV2';
import { uploadImage, getBookCategory, getBookParentCategory } from '../../store/actions/bookAction';
import Countries from "../../assets/resCountries/resCountries.json";
import axios from 'axios';
import { API_V1_BASE_URL } from '../../config/apiConfig';

var cx = require('classnames');

class AddNewPaperBack extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            serverError: {},
            isLoading: false,
            isUploading: false,
            activeTab: 1,
            Name: "",
            Sub_Title: "",
            Author_Name: "",
            Author_Email: "",
            Author_Description: "",
            Author_Image: "",
            Description: "",
            Language: "",
            Image: "",
            Url: "",
            Price: "",
            Category_ID: "",
            P_Category_ID: "",
            ISBN_Num: "",
            Age_Group: "",
            Restricted_Country: "None",
            paperback_weight: "",
            Paperback_ID: "",
            CtaegoryList: [],
            ParentCtaegoryList: [],
            countryList: [],
            selectedValue: [],
            CongratulationModal: false
        };
        this.onChange = this.onChange.bind(this);
    }

    componentWillMount() {
        if (this.props != null && this.props.location.state != null && this.props.location.state.book) {
            this.setValuesOfStates(this.props.location.state.book);
        }
    }

    setValuesOfStates = (book) => {
        var nameArr = [];
        var tmp = [];
        var obj = {};
        if (book?.Restricted_Country) {
            nameArr = book?.Restricted_Country.split(',');
            for (var i = 0; i < nameArr.length; i++) {
                obj = {};
                obj.value = nameArr[i];
                tmp.push(obj);
            }
        }

        this.setState({
            Author_Email: book.Author_Email || "",
            Name: book.Name || "",
            Sub_Title: book.Sub_Title || "",
            Language: book.Language || "",
            Author_Name: book.Author_Name || "",
            Author_Image: book.Author_Image || "",
            Author_Description: book.Author_Description || "",
            ISBN_Num: book.ISBN_Num || "",
            Description: book.Description || "",
            Category_ID: book.Category_ID || "",
            Image: book.Image || "",
            Price: book.Price || "",
            Url: book.Url || "",
            P_Category_ID: book.P_Category_ID || "",
            selectedValue: tmp,
            Restricted_Country: book.Restricted_Country || "None",
            paperback_weight: book.paperback_weight || book.paperbag_weight || "",
            Age_Group: book.Age_Group || "",
            Paperback_ID: book.id || ""
        });
        
        console.log('setValuesOfStates - paperback_weight value:', book.paperback_weight || book.paperbag_weight);
        console.log('setValuesOfStates - full book object:', book);
    }

    componentDidMount() {
        this.setState({ countryList: Countries }, () => console.log(this.state.countryList));

        this.props.getBookCategory().then((res) => {
            console.log(res);
            this.setState({
                CtaegoryList: res.content || [],
            });
        }).catch((err) => {
            console.log(err);
        });

        this.props.getBookParentCategory().then((res) => {
            console.log(res);
            this.setState({
                ParentCtaegoryList: res.content || [],
            });
        }).catch((err) => {
            console.log(err);
        });
    }

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }


    onSelect = (selectedList, selectedValues) => {
        var tmp = [];
        var restricted_countries = '';

        for (var i = 0; i < selectedList.length; i++) {
            tmp.push(selectedList[i]?.value);
        }
        restricted_countries = tmp.join(", ");
        this.setState({ Restricted_Country: restricted_countries });
    }

    onRemove = (selectedList, selectedItem) => {
        var tmp = [];
        var restricted_countries = '';
        for (var i = 0; i < selectedList.length; i++) {
            tmp.push(selectedList[i]?.value);
        }
        restricted_countries = tmp.join(", ");
        this.setState({ Restricted_Country: restricted_countries });
    }

    onImageChange(event, imageType) {
        event.preventDefault();
        let reader = new FileReader();
        let file = event.target.files[0];

        reader.onloadend = () => {
            this.setState({
                file: file,
                image: reader.result
            }, () => {
                this.uploadImage(imageType);
            });
        };
        reader.readAsDataURL(file);
    }

    uploadImage(imageType) {
        const payload = new FormData();
        payload.append('imageType', imageType);
        payload.append('photo', this.state.file);
        this.setState({ isUploading: true });

        this.props.uploadImage(payload).then((res) => {
            console.log(res.content);
            this.setState({ isUploading: false });
            if (res.content.length > 0) {
                if (imageType === 'AUTHOR') {
                    this.setState({ Author_Image: res.content[0].url });
                } else if (imageType === 'BOOK') {
                    this.setState({ Image: res.content[0].url });
                }
            }
        }).catch((err) => {
            this.setState({ isUploading: false });
            if (err.hasOwnProperty('validation')) {
                err.validation.map(obj => {
                    this.setState({ errors: { Author_Image: obj["msg"] } });
                });
            }
        });
    }

    onAddPaperBack = () => {
        // Step 1 and Step 2: Just move to next step without API call
        if (this.state.activeTab === 1 || this.state.activeTab === 2) {
            this.setState({
                activeTab: this.state.activeTab + 1,
            });
            return;
        }

        // Step 3: Make API call to create or update paperback
        if (this.state.activeTab === 3) {
            const isEditMode = this.state.Paperback_ID && this.state.Paperback_ID !== "";
            
            var paperBackData = {
                "Name": this.state.Name,
                "Sub_Title": this.state.Sub_Title,
                "Author_Name": this.state.Author_Name,
                "Author_Email": this.state.Author_Email,
                "Author_Description": this.state.Author_Description,
                "Author_Image": this.state.Author_Image,
                "Description": this.state.Description,
                "Language": this.state.Language,
                "Image": this.state.Image,
                "Url": this.state.Url,
                "Price": this.state.Price,
                "Category_ID": this.state.Category_ID,
                "P_Category_ID": this.state.P_Category_ID,
                "ISBN_Num": this.state.ISBN_Num,
                "Age_Group": this.state.Age_Group || "18+",
                "Restricted_Country": this.state.Restricted_Country ? this.state.Restricted_Country : 'None',
                "paperback_weight": this.state.paperback_weight
            };

            // For update, add id and use PUT API
            if (isEditMode) {
                paperBackData.id = this.state.Paperback_ID;
                // For update API, only send required fields
                var updatePaperBackData = {
                    "id": this.state.Paperback_ID,
                    "Name": this.state.Name,
                    "Author_Name": this.state.Author_Name,
                    "Author_Email": this.state.Author_Email,
                    "Description": this.state.Description,
                    "Language": this.state.Language,
                    "Image": this.state.Image,
                    "Url": this.state.Url,
                    "Price": this.state.Price,
                    "paperback_weight": this.state.paperback_weight,
                    "Active_Status": true
                };

                this.setState({ isLoading: true, errors: {}, serverError: {} });

                apiV2.put('/api/publisher/paperback', updatePaperBackData).then((res) => {
                    console.log('Update Response:', res);
                    console.log('Update Response Data:', res.data);
                    console.log('Update Response Status:', res.status);
                    this.setState({ isLoading: false });
                    
                    // Redirect on success - check multiple conditions
                    if (res.status === 201 || res.status === 200) {
                        this.props.history.push('/paperback');
                    } else if (res.data && (res.data.status === true || res.data.data)) {
                        this.props.history.push('/paperback');
                    } else {
                        // Even if response structure is different, redirect on 2xx status
                        this.props.history.push('/paperback');
                    }
                }).catch((err) => {
                    this.setState({ isLoading: false });
                    var validationError = {};
                    var serverError = [];

                    if (err.response && err.response.data && err.response.data.errors) {
                        err.response.data.errors.map(obj => {
                            if (obj.param) {
                                validationError[obj.param] = obj.msg;
                            } else {
                                serverError = [...serverError, obj];
                            }
                        });
                        this.setState({ errors: validationError });
                        this.setState({ serverError: serverError });
                    } else {
                        this.setState({ serverError: [{ "msg": "server not responding" }] });
                    }
                });
                return;
            }

            // For create, use POST API
            this.setState({ isLoading: true, errors: {}, serverError: {} });

            apiV2.post('/api/paperback', paperBackData).then((res) => {
                console.log('Create Response:', res);
                console.log('Create Response Data:', res.data);
                console.log('Create Response Status:', res.status);
                this.setState({ isLoading: false });
                
                // Redirect on success - check multiple conditions
                if (res.status === 201 || res.status === 200) {
                    this.props.history.push('/paperback');
                } else if (res.data && (res.data.status === true || res.data.data)) {
                    this.props.history.push('/paperback');
                } else {
                    // Even if response structure is different, redirect on 2xx status
                    this.props.history.push('/paperback');
                }
            }).catch((err) => {
                this.setState({ isLoading: false });
                var validationError = {};
                var serverError = [];

                if (err.response && err.response.data && err.response.data.errors) {
                    err.response.data.errors.map(obj => {
                        if (obj.param) {
                            validationError[obj.param] = obj.msg;
                        } else {
                            serverError = [...serverError, obj];
                        }
                    });
                    this.setState({ errors: validationError });
                    this.setState({ serverError: serverError });
                } else {
                    this.setState({ serverError: [{ "msg": "server not responding" }] });
                }
            });
        }
    }

    onManagePaperBack = () => {
        this.props.history.push('/paperback');
    }

    togglecongratulationModal = () => {
        this.setState({ CongratulationModal: !this.state.CongratulationModal });
    }

    handlecongratulationClosemodal = (e) => {
        this.setState({ CongratulationModal: !this.state.CongratulationModal });
    }

    onClickBottomBar = (val) => {
        this.setState({
            activeTab: val
        });
    }

    render() {
        const { isUploading, isLoading, errors } = this.state;

        if (isLoading && this.state.activeTab === 1) {
            return (
                <div className="loader-large"></div>
            );
        }

        return (
            <div>
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <Modal
                        dialogClassName="col-sm-12"
                        show={this.state.CongratulationModal}
                        size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >
                        <div className="modal-body">
                            <div className="container">
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-4">
                                    <div className="row">
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                                            <img className="pointerr" src={BackArrow} onClick={() => this.handlecongratulationClosemodal()} alt="back"></img>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 text-right">
                                            <img className="pointerr" src={crossbtn} onClick={() => this.handlecongratulationClosemodal()} alt="close"></img>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center pb-4 mt-3">
                                    <img src={storytelling} alt="congratulations"></img>
                                    <p className="poppins_medium mt-4 congratulation_text">Congratulation</p>
                                    <p className="poppins_light mt-4 modal_text">Your Paperback is under review in order to track your book go to Manage Paperbacks</p>
                                    <button className="col-xl-4 poppins_semibold modalbtn" onClick={() => this.onManagePaperBack()}>Manage Paperbacks</button>
                                </div>
                            </div>
                        </div>
                    </Modal>

                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 managebookContainer">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0">
                                <p className="poppins_semibold managebookheading">Add New PaperBack</p>
                            </div>

                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="row">
                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mt-3" onClick={() => this.onClickBottomBar(1)}>
                                        <div className={cx({ "manageBookTopBarCard": true, "manageBookTopBarCard_active": this.state.activeTab === 1 })}>
                                            <label className="poppins_medium ml-3 manageBookTopBarCard-Heading mt-2 mb-0">Paperback Detail</label><br></br>
                                            <label className="poppins_light ml-4 manageBookTopBarCard-Text mt-2 mb-0">
                                                <img className="ml-2 mr-2" src={progressicon} alt="progress" />
                                                {this.state.activeTab === 1 ? "In Progress..." : "Completed"}
                                            </label>
                                        </div>
                                    </div>
                                    {this.state.Name && this.state.Language && this.state.Category_ID && this.state.Description && this.state.Author_Name && this.state.Author_Email && this.state.Author_Description && this.state.Author_Image ? (
                                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mt-3" onClick={() => this.onClickBottomBar(2)}>
                                            <div className={cx({ "manageBookTopBarCard": true, "manageBookTopBarCard_active": this.state.activeTab === 2 })}>
                                                <label className="poppins_medium ml-3 manageBookTopBarCard-Heading mt-2 mb-0">Paperback Content</label><br></br>
                                                <label className="poppins_light ml-4 manageBookTopBarCard-Text mt-2 mb-0">
                                                    <img className="ml-2 mr-2" src={progressicon} alt="progress"></img>
                                                    {this.state.activeTab === 2 ? "In Progress..." : this.state.activeTab === 1 ? "Not Started..." : "Completed..."}
                                                </label>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mt-3">
                                            <div className={cx({ "manageBookTopBarCard": true, "manageBookTopBarCard_active": this.state.activeTab === 2 })}>
                                                <label className="poppins_medium ml-3 manageBookTopBarCard-Heading mt-2 mb-0">Paperback Content</label><br></br>
                                                <label className="poppins_light ml-4 manageBookTopBarCard-Text mt-2 mb-0">
                                                    <img className="ml-2 mr-2" src={progressicon} alt="progress"></img>
                                                    {this.state.activeTab === 2 ? "In Progress..." : this.state.activeTab === 1 ? "Not Started..." : "Completed..."}
                                                </label>
                                            </div>
                                        </div>
                                    )}
                                    {this.state.Url && this.state.Image ? (
                                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mt-3" onClick={() => this.onClickBottomBar(3)}>
                                            <div className={cx({ "manageBookTopBarCard": true, "manageBookTopBarCard_active": this.state.activeTab === 3 })}>
                                                <label className="poppins_medium ml-3 manageBookTopBarCard-Heading mt-2 mb-0">Paperback Pricing</label><br></br>
                                                <label className="poppins_light ml-4 manageBookTopBarCard-Text mt-2 mb-0">
                                                    <img className="ml-2 mr-2" src={progressicon} alt="progress"></img>
                                                    {this.state.activeTab !== 3 ? "Not Started..." : "In Progress..."}
                                                </label>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mt-3">
                                            <div className={cx({ "manageBookTopBarCard": true, "manageBookTopBarCard_active": this.state.activeTab === 3 })}>
                                                <label className="poppins_medium ml-3 manageBookTopBarCard-Heading mt-2 mb-0">Paperback Pricing</label><br></br>
                                                <label className="poppins_light ml-4 manageBookTopBarCard-Text mt-2 mb-0">
                                                    <img className="ml-2 mr-2" src={progressicon} alt="progress"></img>
                                                    {this.state.activeTab !== 3 ? "Not Started..." : "In Progress..."}
                                                </label>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {this.state.activeTab === 1 ? (
                                <>
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
                                        <div className="bookDescriptionCard">
                                            <p className="manageBookTopBarCard-Heading poppins_medium mt-2 mb-0">Book Description</p>
                                            <label className="poppins_light manageBookTopBarCard-Text mt-2 mb-0">Please enter book information as per requirements</label>
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
                                                <div className="row">
                                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-4 mt-1 vertical_center text-right">
                                                        <p className="manageBookTopBarCard-Heading poppins_medium mb-0">Book Title</p>
                                                    </div>
                                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-8 col-8 mt-1 vertical_center4">
                                                        <input className="col-xl-12 managebookInput" name="Name" onChange={this.onChange} value={this.state.Name}></input>
                                                        {errors.Name && <div className="invaliderrorAddNewBook">{errors.Name}</div>}
                                                    </div>
                                                    <div className="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-4 mt-1 vertical_center text-right">
                                                        <p className="manageBookTopBarCard-Heading poppins_medium mb-0">Language</p>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-8 col-8 mt-1 vertical_center">
                                                        <select className="col-xl-12 managebookInput" name="Language" onChange={this.onChange} value={this.state.Language}>
                                                            <option value="">Please Select</option>
                                                            <option value='English'>English</option>
                                                            <option value='Urdu'>Urdu</option>
                                                        </select>
                                                        {errors.Language && <div className="invaliderrorAddNewBook">{errors.Language}</div>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
                                                <div className="row">
                                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-4 vertical_center text-right">
                                                        <label className="manageBookTopBarCard-Heading poppins_medium mb-0">Subtitle</label>
                                                        <label className="manageBookTopBarCard-Text poppins_light mb-0"> (Optional)</label><br></br>
                                                    </div>
                                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-8 col-8 vertical_center4">
                                                        <input className="col-xl-12 managebookInput" name="Sub_Title" onChange={this.onChange} value={this.state.Sub_Title}></input>
                                                        {errors.Sub_Title && <div className="invaliderrorAddNewBook">{errors.Sub_Title}</div>}
                                                    </div>
                                                    <div className="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-4 vertical_center text-right">
                                                        <p className="manageBookTopBarCard-Heading poppins_medium mb-0">Parent Category</p>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-8 col-8 vertical_center">
                                                        <select className="col-xl-12 managebookInput" name="P_Category_ID" onChange={this.onChange} value={this.state.P_Category_ID}>
                                                            <option value="">--Please Select--</option>
                                                            {this.state.ParentCtaegoryList.map((item, index) =>
                                                                <option key={index} value={item.Category_ID}>{item.Category_Name}</option>
                                                            )}
                                                        </select>
                                                        {errors.P_Category_ID && <div className="invaliderrorAddNewBook">{errors.P_Category_ID}</div>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
                                                <div className="row">
                                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-4 vertical_center text-right">
                                                        <label className="manageBookTopBarCard-Heading poppins_medium mb-0">ISBN Number</label>
                                                        <label className="manageBookTopBarCard-Text poppins_light mb-0"> (Optional)</label><br></br>
                                                    </div>
                                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-8 col-8 vertical_center4">
                                                        <input className="col-xl-12 managebookInput" name="ISBN_Num" onChange={this.onChange} value={this.state.ISBN_Num}></input>
                                                        {errors.ISBN_Num && <div className="invaliderrorAddNewBook">{errors.ISBN_Num}</div>}
                                                    </div>
                                                    <div className="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-4 vertical_center text-right">
                                                        <p className="manageBookTopBarCard-Heading poppins_medium mb-0">Category</p>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-8 col-8 vertical_center">
                                                        <select className="col-xl-12 managebookInput" name="Category_ID" onChange={this.onChange} value={this.state.Category_ID}>
                                                            <option value="">--Please Select--</option>
                                                            {this.state.CtaegoryList.map((item, index) =>
                                                                <option key={index} value={item.Category_ID}>{item.Category_Name}</option>
                                                            )}
                                                        </select>
                                                        {errors.Category_ID && <div className="invaliderrorAddNewBook">{errors.Category_ID}</div>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
                                                <div className="row">
                                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-4 vertical_center text-right">
                                                        <label className="manageBookTopBarCard-Heading poppins_medium mb-0">Age Group</label>
                                                        <label className="manageBookTopBarCard-Text poppins_light mb-0"> (Optional)</label><br></br>
                                                    </div>
                                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-8 col-8 vertical_center4">
                                                        <input className="col-xl-12 managebookInput" name="Age_Group" onChange={this.onChange} value={this.state.Age_Group} placeholder="e.g., 18+"></input>
                                                        {errors.Age_Group && <div className="invaliderrorAddNewBook">{errors.Age_Group}</div>}
                                                    </div>
                                                    <div className="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-4 vertical_center text-right">
                                                        <p className="manageBookTopBarCard-Heading poppins_medium mb-0">Restricted Countries</p>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-8 col-8 vertical_center">
                                                        <Multiselect
                                                            options={this.state.countryList}
                                                            selectedValues={this.state.selectedValue}
                                                            onSelect={this.onSelect}
                                                            onRemove={this.onRemove}
                                                            displayValue="value"
                                                            showCheckbox={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
                                                <div className="row">
                                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-4 text-right">
                                                        <label className="manageBookTopBarCard-Heading poppins_medium mb-0">About the Book</label>
                                                    </div>
                                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-8 col-8">
                                                        <textarea className="col-xl-12 managebooktextarea" name="Description" onChange={this.onChange} value={this.state.Description}></textarea>
                                                        {errors.Description && <div className="invaliderrorAddNewBookDescription">{errors.Description}</div>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
                                        <div className="bookDescriptionCard">
                                            {this.state.isUploading && <div className="loader-small"></div>}
                                            <p className="manageBookTopBarCard-Heading poppins_medium mt-2 mb-0">Author Details</p>
                                            <label className="poppins_light manageBookTopBarCard-Text mt-2 mb-0">Please enter Author information as per requirements</label>
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
                                                <div className="row">
                                                    <div className="col-xl-7 col-lg-7 col-md-7 col-sm-12 col-12 mt-4">
                                                        <div className="row">
                                                            <div className="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5 vertical_center text-right">
                                                                <p className="manageBookTopBarCard-Heading poppins_medium mb-0">Author Name</p>
                                                            </div>
                                                            <div className="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 vertical_center4">
                                                                <input className="col-xl-12 managebookInput" name="Author_Name" onChange={this.onChange} value={this.state.Author_Name}></input>
                                                                {errors.Author_Name && <div className="invaliderrorAddNewBook">{errors.Author_Name}</div>}
                                                            </div>
                                                            <div className="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5 mt-4 vertical_center text-right">
                                                                <p className="manageBookTopBarCard-Heading poppins_medium mb-0">Author Email</p>
                                                            </div>
                                                            <div className="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 mt-4 vertical_center4">
                                                                <input className="col-xl-12 managebookInput" name="Author_Email" onChange={this.onChange} value={this.state.Author_Email}></input>
                                                                {errors.Author_Email && <div className="invaliderrorAddNewBook">{errors.Author_Email}</div>}
                                                            </div>
                                                            <div className="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5 mt-4 vertical_center text-right">
                                                                <p className="manageBookTopBarCard-Heading poppins_medium mb-0">About the Author</p>
                                                            </div>
                                                            <div className="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 mt-4 vertical_center4">
                                                                <textarea className="col-xl-12 managebooktextarea" name="Author_Description" onChange={this.onChange} value={this.state.Author_Description}></textarea>
                                                                {errors.Author_Description && <div className="invaliderrorAddNewBookDescription">{errors.Author_Description}</div>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 mt-4">
                                                        <div className="row">
                                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 vertical_center">
                                                                <p className="manageBookTopBarCard-Heading poppins_medium mb-0">Author Image</p>
                                                            </div>
                                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 vertical_center4">
                                                                <div className="row">
                                                                    <div className="col-xl-4 col-lg-5 col-md-6 col-sm-6 col-12 mt-4 vertical_center4">
                                                                        <div>
                                                                            <img src={this.state.Author_Image === "" ? authorimagePlaceholder : this.state.Author_Image} style={{ width: '100%' }} alt="author"></img>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 mt-4">
                                                                        <button className="col-xl-12 poppins_semibold uploadbtn" onClick={(e) => this.uploadAuthor.click()}>
                                                                            UPLOAD FILE
                                                                            <input type="file" onChange={(e) => this.onImageChange(e, 'AUTHOR')} name="Author_Image" ref={(ref) => this.uploadAuthor = ref} style={{ display: 'none' }} />
                                                                        </button>
                                                                        <p>Not be more than 1 MB</p>
                                                                    </div>
                                                                </div>
                                                                {errors.Author_Image && <div className="invaliderrorAddNewBookImage">{errors.Author_Image}</div>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : this.state.activeTab === 2 ? (
                                <>
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
                                        <div className="bookDescriptionCard">
                                            <p className="manageBookTopBarCard-Heading poppins_medium mt-2 mb-0">Paperback Files</p>
                                            <label className="poppins_light manageBookTopBarCard-Text mt-2 mb-0">Please provide your book content</label>
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
                                                <div className="row">
                                                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mt-3">
                                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                            <div className="row">
                                                                <div className="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1"></div>
                                                                <div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-12">
                                                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ml-2">
                                                                        <div className="EpubFile_roundDiv">
                                                                            <label className="poppins_bold EpubFile_roundDiv_text">1</label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ml-4 mt-3">
                                                                        <p className="manageBookTopBarCard-Heading poppins_medium mt-2 mb-0">PDF Book Link</p>
                                                                        <label className="poppins_light manageBookTopBarCard-Text mt-2 mb-0">Enter downloadable link for PDF book</label><br></br>
                                                                        <input 
                                                                            className="col-xl-12 managebookInput mt-3" 
                                                                            type="url" 
                                                                            name="Url" 
                                                                            onChange={this.onChange} 
                                                                            value={this.state.Url}
                                                                            placeholder="https://example.com/book.pdf"
                                                                        ></input>
                                                                        {errors.Url && <div className="epubEroor">{errors.Url}</div>}
                                                                        
                                                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3" style={{ 
                                                                            backgroundColor: '#F8F9FA', 
                                                                            border: '1px solid #E0E0E0', 
                                                                            borderRadius: '6px', 
                                                                            padding: '15px',
                                                                            marginTop: '15px'
                                                                        }}>
                                                                            <p className="poppins_medium mb-2" style={{ fontSize: '13px', color: '#0D1B2A', marginBottom: '10px' }}>Note:</p>
                                                                            <ul className="poppins_light" style={{ fontSize: '12px', color: '#0D1B2A', marginBottom: '0', paddingLeft: '20px' }}>
                                                                                <li>Please provide a direct downloadable link to your PDF book file.</li>
                                                                                <li>You can use services like Google Drive, Dropbox, or other file hosting services.</li>
                                                                                <li>The link must allow direct download (not preview mode).</li>
                                                                                <li>For Google Drive, use format: <code style={{ backgroundColor: '#E8E8E8', padding: '2px 4px', borderRadius: '3px' }}>https://drive.google.com/uc?export=download&id=FILE_ID</code></li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mt-3">
                                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                            <div className="row">
                                                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                                        <div className="EpubFile_roundDiv">
                                                                            <label className="poppins_bold EpubFile_roundDiv_text">2</label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ml-3">
                                                                        <p className="manageBookTopBarCard-Heading poppins_medium mt-2 mb-0">Upload Cover</p>
                                                                        <label className="poppins_light manageBookTopBarCard-Text mt-2 mb-0">Upload a cover you already have (JPG/TIF only)</label><br></br>
                                                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 vertical_center4">
                                                                            <div className="row">
                                                                                <div className="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-12 mt-4 vertical_center4">
                                                                                    <div>
                                                                                        <img src={this.state.Image === '' ? imageplaceholder : this.state.Image} style={{ width: '100%', borderRadius: '15px' }} alt="cover"></img>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-12 mt-4">
                                                                                    <button className="col-xl-12 poppins_semibold uploadbtn" onClick={(e) => this.uploads.click()}>
                                                                                        UPLOAD FILE
                                                                                        <input id="myInput" type="file" accept="image/*" onChange={(e) => this.onImageChange(e, 'BOOK')} name="Url" ref={(ref) => this.uploads = ref} style={{ display: 'none' }} />
                                                                                    </button>
                                                                                    <p className="mb-0 poppins_light manageBookTopBarCard-Text">Not be more then 2 MB</p>
                                                                                    <p className="mb-0 poppins_light manageBookTopBarCard-Text">Pixel Size 1645 x 2550 (Recommended)</p>
                                                                                    <p className="mb-0 poppins_light manageBookTopBarCard-Text">Resolution 150 DPI</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {errors.Book_Cover && <div className="epubEroor">{errors.Book_Cover}</div>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : this.state.activeTab === 3 && (
                                <>
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
                                        <div className="bookDescriptionCard">
                                            <p className="manageBookTopBarCard-Heading poppins_medium mt-2 mb-0">Pricing</p>
                                            <label className="poppins_light manageBookTopBarCard-Text mt-2 mb-0">Please enter pricing information</label>
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
                                                <div className="row">
                                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-4 vertical_center text-right">
                                                        <p className="manageBookTopBarCard-Heading poppins_medium mb-0">Book Price</p>
                                                    </div>
                                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-8 col-8 vertical_center4">
                                                        <label className="labelinside poppins_light">Currency (PKR)</label>
                                                        <input className="col-xl-12 pricebookInput" placeholder="100.00" type="number" name="Price" onChange={this.onChange} value={this.state.Price}></input>
                                                        {errors.Price && <div className="invaliderrorAddNewBook">{errors.Price}</div>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
                                                <div className="row">
                                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-4 vertical_center text-right">
                                                        <label className="manageBookTopBarCard-Heading poppins_medium mb-0">Paperbag Weight</label>
                                                        <label className="manageBookTopBarCard-Text poppins_light mb-0"> (Optional)</label><br></br>
                                                    </div>
                                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-8 col-8 vertical_center4">
                                                        <input className="col-xl-12 managebookInput" name="paperback_weight" onChange={this.onChange} value={this.state.paperback_weight} placeholder="e.g., 500g"></input>
                                                        {errors.paperback_weight && <div className="invaliderrorAddNewBook">{errors.paperback_weight}</div>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
                                <div className="text-right">
                                    <button className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 poppins_semibold uploadbtn" onClick={this.onAddPaperBack} disabled={isLoading}>
                                        {isLoading ? 'Saving...' : 'Save & Continue'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    auth: state.auth
});

const mapDispatchToProps = ({
    uploadImage,
    getBookCategory,
    getBookParentCategory,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddNewPaperBack);
